import { render, staticRenderFns } from "./saldo.vue?vue&type=template&id=6a2f3084&scoped=true&"
import script from "./saldo.js?vue&type=script&lang=js&"
export * from "./saldo.js?vue&type=script&lang=js&"
import style0 from "./saldo.scss?vue&type=style&index=0&id=6a2f3084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f3084",
  null
  
)

export default component.exports